import { useMemo } from "react";
import {
  SUBMITTED_BEFORE_FILTER_OPTIONS,
  SearchAndFilterTypes,
} from "src/constants";
import { ButtonFilter, CommonFilterProps, FormFilter } from "../CommonFilters";

export const HistoricalStatusFilter = (props: CommonFilterProps) => {
  const options = useMemo(() => {
    return SUBMITTED_BEFORE_FILTER_OPTIONS.map((status) => ({
      label: status.label,
      id: status.key,
    }));
  }, []);

  return (
    <FormFilter label="Historical status">
      <ButtonFilter
        options={options}
        filterKey={SearchAndFilterTypes.SubmittedBefore}
        {...props}
      />
    </FormFilter>
  );
};
